const framePopup = {
    FeaturedBoxFunnel: () => import("@/common/FramePopup/Popup/FeaturedBoxFunnel"),//FeaturedBox漏斗筛选
    MyBoxesFunnel: () => import("@/common/FramePopup/Popup/MyBoxesFunnel"),//FeaturedBox漏斗
    RechargeWindow: () => import("@/common/FramePopup/Popup/rechargeWindow"),//充值窗口
  };
  export default framePopup;
  